/* Poolboy cart conversion (Nugget, Oct 2026)
   1. Any add to cart form opens the cart drawer instead of loading /cart.
   2. Bundle quick add buttons in the drawer and cart page.
   3. Delivery date estimate on product pages, drawer and cart page. */
(function(){
  if (window.__pbcart) return; window.__pbcart = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function drawer(){ var d = document.querySelector('cart-drawer'); return d && typeof d.renderContents === 'function' ? d : null; }
  function onCartPage(){ return /^\/cart\/?$/.test(location.pathname); }
  function isAddForm(f){
    if (!f || f.tagName !== 'FORM') return false;
    try { return /\/cart\/add(\.js)?$/.test(new URL(f.getAttribute('action') || '', location.href).pathname); } catch(e){ return false; }
  }
  function busy(btn, on){
    if (!btn) return;
    btn.disabled = !!on; btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.classList.toggle('pb-busy', !!on);
  }
  function show(state){
    var d = drawer(); if (!d) { location.href = ROOT + 'cart'; return; }
    d.classList.remove('is-empty');
    d.renderContents(state);
    setTimeout(eta, 50);
    document.dispatchEvent(new CustomEvent('pb:cart-updated', { detail: state }));
  }
  function post(body, json){
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: json ? { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } : { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    }).then(function(r){ return r.json().then(function(j){ if (!r.ok || j.status) throw j; return j; }); });
  }
  function withSections(state){
    if (state && state.sections && state.sections['cart-drawer']) return Promise.resolve(state);
    return fetch(ROOT + '?sections=' + SECTIONS).then(function(r){ return r.json(); }).then(function(s){ state = state || {}; state.sections = s; return state; });
  }

  /* 1. product forms open the drawer */
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!isAddForm(f) || f.closest('product-form') || f.hasAttribute('data-pb-native')) return;
    if (onCartPage() || !drawer()) return;
    e.preventDefault();
    var btn = e.submitter || f.querySelector('[type=submit]');
    busy(btn, true);
    var fd = new FormData(f);
    if (e.submitter && e.submitter.name) fd.append(e.submitter.name, e.submitter.value);
    fd.append('sections', SECTIONS);
    fd.append('sections_url', location.pathname);
    post(fd, false).then(withSections).then(show).catch(function(err){
      busy(btn, false);
      if (err && (err.description || err.message) && err.status === 422) { alert(err.description || err.message); return; }
      f.setAttribute('data-pb-native', '1'); HTMLFormElement.prototype.submit.call(f);
    }).then(function(){ busy(btn, false); });
  }, true);

  /* 2a. bundle colour swatches: swap photo, colour name and variant */
  document.addEventListener('click', function(e){
    var s = e.target.closest && e.target.closest('[data-pb-sw]'); if (!s) return;
    e.preventDefault();
    var row = s.closest('.pb-bundle__item'); if (!row) return;
    row.querySelectorAll('[data-pb-sw]').forEach(function(x){ x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
    s.classList.add('is-on'); s.setAttribute('aria-checked', 'true');
    var img = row.querySelector('.pb-bundle__img'), t = row.querySelector('.pb-bundle__vt'), add = row.querySelector('[data-pb-add]');
    if (img && s.getAttribute('data-img')) img.src = s.getAttribute('data-img');
    if (t) t.textContent = s.getAttribute('data-title');
    if (add) { add.setAttribute('data-pb-add', s.getAttribute('data-pb-sw')); add.setAttribute('aria-label', 'Add ' + (row.querySelector('.pb-bundle__t') || {}).textContent + ', ' + s.getAttribute('data-title')); }
  });

  /* 2. bundle quick add */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-pb-add]'); if (!b) return;
    e.preventDefault();
    var id = parseInt(b.getAttribute('data-pb-add'), 10); if (!id) return;
    busy(b, true);
    var inDrawer = !!b.closest('cart-drawer');
    post(JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: SECTIONS, sections_url: location.pathname }), true)
      .then(function(state){
        if (inDrawer && drawer()) return withSections(state).then(show);
        location.reload();
      })
      .catch(function(err){ busy(b, false); alert((err && (err.description || err.message)) || 'That did not add. Try again.'); });
  });

  /* 3. delivery estimate: dispatch same working day before 1pm NZ, arrives 2 to 4 working days after dispatch */
  var CUTOFF = 13;
  var HOLIDAYS = ['2026-10-26','2026-12-25','2026-12-28','2027-01-01','2027-01-04','2027-02-08','2027-03-26','2027-03-29','2027-04-26','2027-06-07','2027-06-25','2027-10-25','2027-12-27','2027-12-28','2028-01-03','2028-01-04'];
  function nzNow(){
    var p = {}; new Intl.DateTimeFormat('en-NZ', { timeZone: 'Pacific/Auckland', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function(x){ p[x.type] = x.value; });
    return { d: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), h: +p.hour % 24 };
  }
  function key(d){ return d.toISOString().slice(0, 10); }
  function working(d){ var w = d.getUTCDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(key(d)) === -1; }
  function next(d){ var n = new Date(d.getTime()); do { n.setUTCDate(n.getUTCDate() + 1); } while (!working(n)); return n; }
  function addWorking(d, n){ var x = d; for (var i = 0; i < n; i++) x = next(x); return x; }
  function fmt(d, month){ var o = { timeZone: 'UTC', weekday: 'short', day: 'numeric' }; if (month) o.month = 'short'; return new Intl.DateTimeFormat('en-NZ', o).format(d).replace(',', ''); }
  function range(){
    var n = nzNow(), dispatch = (working(n.d) && n.h < CUTOFF) ? n.d : next(n.d);
    var a = addWorking(dispatch, 2), b = addWorking(dispatch, 4);
    var same = a.getUTCMonth() === b.getUTCMonth();
    return fmt(a, !same) + ' to ' + fmt(b, true);
  }
  function eta(){
    /* NZ delivery times only; AU estimate needs AU dispatch times */
    if ((window.Shopify && window.Shopify.country && window.Shopify.country !== 'NZ') || /poolboycollective\.com$/.test(location.hostname)) return;
    var r; try { r = range(); } catch(e){ return; }
    document.querySelectorAll('[data-pb-eta]').forEach(function(el){ el.textContent = el.getAttribute('data-pb-eta-prefix') ? el.getAttribute('data-pb-eta-prefix') + r : r; el.hidden = false; });
    var add = document.querySelector('.pb-ph__add');
    if (add && !document.querySelector('.pb-eta-pdp')) {
      var anchor = add.closest('form') || add.parentElement;
      var line = document.createElement('p');
      line.className = 'pb-eta-pdp';
      line.innerHTML = '<svg viewBox="0 0 20 14" aria-hidden="true"><path d="M1 2h11v8H1zM12 5h4l3 3v2h-7zM4.5 12.5a1.5 1.5 0 1 0 0-.01M15.5 12.5a1.5 1.5 0 1 0 0-.01" fill="none" stroke="currentColor" stroke-width="1.2"/></svg><span>Order today, arrives <strong></strong>. Free NZ delivery.</span>';
      line.querySelector('strong').textContent = r;
      anchor.parentNode.insertBefore(line, anchor.nextSibling);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', eta); else eta();
  window.PBCart = { eta: eta, range: range };
})();
